import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';

import adminConfig from '@/features/promotions/config.json';

export const YA_TAGS = [
	'self_discovery',
	'friendship',
	'young_lovers',
	'identity_crisis',
	'first_love',
	'teens',
	'teenage_life',
	'teenage_love',
	'high_school_life',
	'high_school',
	'high_school_hunk',
	'college_life',
	'promcoming_of_age',
	'young_man',
	'young_woman',
	'adulthood',
];

export const YA_SUBGENRES = ['syad', 'dyad'];

export function useYAExperiment({
	title,
	promotionShortName,
}: {
	title: MaybeRefOrGetter<TitleDetail>;
	promotionShortName: MaybeRefOrGetter<string | undefined>;
}) {
	const { country } = useLanguageStore();

	const _title = computed(() => toValue(title));
	const _promotionShortName = computed(() => toValue(promotionShortName));

	const adminConfigActivation = adminConfig?.young_adult_prime?.active ?? false;

	const isUSYoungAdultTitle = computed(() => {
		if (!adminConfigActivation) return false;

		if (country.value !== 'US' || _promotionShortName.value !== 'amp') return false;
		if (_title.value.content.subgenres.some(sub => YA_SUBGENRES.includes(sub.content.shortName || ''))) return true;

		return (
			!!_title.value.content.tags &&
			_title.value.content.tags.map(tagObject => tagObject.technicalName).some(tag => YA_TAGS.includes(tag))
		);
	});

	const yaExpFreeTrialText = computed(() => (isUSYoungAdultTitle.value ? '6 Months Free' : null));

	const yaExpFreeTrialPrice = computed(() => (isUSYoungAdultTitle.value ? '$7.49' : null));

	function setYAExpTags(url: ClickoutUrl) {
		if (!isUSYoungAdultTitle.value) return url;

		return url
			.set('r', 'https://www.amazon.com/joinyoungadult')
			.set('uct_ct', 'bypass')
			.skipUCT2()
			.skipYieldOptimization()
			.setOnOffer('tag', 'yaexp-us-ft-v1-20');
	}

	return {
		setYAExpTags,
		yaExpFreeTrialText,
		yaExpFreeTrialPrice,
		isUSYoungAdultTitle,
	};
}
